import { combineReducers } from 'redux';
// import { items, itemsHaveError, itemsAreLoading } from './items';

 export default combineReducers({
//     items,
//     itemsHaveError,
//     itemsAreLoading
 });








//  map.on('click', 'second-layer', function (e) {
//     // map.flyTo({ center: e.features[0].geometry.coordinates });
//     console.log(e.features[0].properties._name, "second layer click----");

//     console.log(e.features[0].layer.id, "e in cl=ick....")

//     layer2_count++;
//     map_upSideShowing_layers[1] = {
//       name: e.features[0].properties._name,
//       layer: e.features[0].layer.id
//     }
//     var bbox = [
//       [e.point.x - 5, e.point.y - 5],
//       [e.point.x + 5, e.point.y + 5]
//     ];
//     var features = map.queryRenderedFeatures(bbox, {
//       layers: ['second-layer']
//     });

//     console.log(features, "features 3rlayer....")
//     let center = features[0].geometry.coordinates[0][0];
//     th.setState({
//       layer1_displayDataArr: th.state.layer3_displayDataArr,
//       center: center,
//       titel: "locality",
//       presentLayer: 3,
//       map_upSideShowing_layers: map_upSideShowing_layers
//     })
//     map.flyTo({
//       center: th.state.center,
//       zoom: 12
//     });

//     if (layer2_count <= 1) {
//       map.addLayer({
//         'id': 'third-layer',
//         'type': 'fill',
//         'source': {
//           'type': 'geojson',
//           'data': th.state.thirdLayerGeoJson,
//         },
//         'layout': {},
//         'paint': {
//          'fill-color': [
//             'interpolate',
//             ['linear'],
//             ['get', 'ddn_count'],
//             1,
//             '#FFEDA0',
//             100,
//             '#FED976',
//             1000,
//             '#FEB24C',
//             5000,
//             '#FD8D3C',
//             10000,
//             '#FC4E2A',
//             20000,
//             '#E31A1C',
//             25000,
//             '#BD0026',
//             50000,
//             '#800026',
//             500000,
//             '#800026',
//           ],
//           'fill-opacity': [
//             'case',
//             ['boolean', ['feature-state', 'hover'], false],
//             1,
//             0.5
//           ]
//         }
//       });

//       map.addLayer({
//         'id': 'third-layer-borders',
//         'type': 'line',
//         'source': {
//           'type': 'geojson',
//           'data': th.state.thirdLayerGeoJson,
//         },
//         'layout': {},
//         'paint': {
//           'line-color': '#0d2d8f',
//           'line-width': 2
//         }
//       });

//       map.setLayoutProperty('second-layer', 'visibility', 'none')
//       map.setLayoutProperty('second-layer-borders', 'visibility', 'none')

//     } else {
//       map.setLayoutProperty('second-layer', 'visibility', 'none');
//       map.setLayoutProperty('second-layer-borders', 'visibility', 'none');
//       map.setLayoutProperty('third-layer', 'visibility', 'visible');
//       map.setLayoutProperty('third-layer-borders', 'visibility', 'visible');
//       th.zoomLayers('third-layer')
//     }


//   })